// extracted by mini-css-extract-plugin
module.exports = {"animate":"Icons_animate__N_0E2","up":"Icons_up__ynLJV","right":"Icons_right__wL9Qu","down":"Icons_down__hqtok","left":"Icons_left__TMI1U"};